import {
  Button,
  Icon,
  Input,
  Typography,
  CircularLoader,
} from "@plum-xoxo/admin-dsm";
import React, { useEffect, useState } from "react";
import Templates from "../../modules/Templates";
import theme from "../../theme";
import LogoPreview from "./components/LogoPreview";
import styled from "styled-components";
import EditLogoModal from "./EditLogoModal";
import TemplatePreview from "./components/TemplatePreview";
import XoxoLinkRewardBody from "./components/XoxoLinkRewardBody";
import XoxoCodeRewardBody from "./components/XoxoCodeRewardBody";
import XoxoPointRewardBody from "./components/XoxoPointRewardBody";
import PlumProRewardBody from "./components/PlumProRewardBody";
import EmailFooter from "./components/EmailFooter";
import { getHowToUseLinks } from "./components/constants";
import { makeRequestAuth } from "../../utils/globals";
import TemplateModal from "./TemplateModal";
import profileService from "../../services/profileService";
import config from "config";
import EditMask from "./components/EditMask";
import EditBtnTextModal from "./EditBtnTextModal";
import transactionService from "../../services/transactionService";
import EditMsgTextModal from "./EditMsgTextModal";
import { NotificationManager } from "react-notifications";

const CustomMsgDiv = styled.div`
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.palette.dark.c200};
  opacity: 0;
  z-index: 99;
  &:hover {
    opacity: 1;
  }
`;

const NewEmailPreview = (props) => {
  const [editMessage, setEditMessage] = useState(false);
  const [templateModal, setTemplateModal] = useState(false);
  const [editSubject, seteditSubject] = useState(false);
  const [editHeading, setEditHeading] = useState(false);
  const [cardImages, setCardImages] = useState([]);
  const [loader, setLoader] = useState(false);
  const [maxLimit, setMaxLimit] = useState(250);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [editButtonText, setEditButtonText] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(false);
  const [openLogoUploadModal, setOpenLogoUploadModal] = useState(false);
  const [isDesktopPreview, setIsDesktopPreview] = useState(false);
  const [openBtnTextModal, setOpenBtnTextModal] = useState(false);
  const [openMsgTextModal, setOpenMsgTextModal] = useState(false);

  const {
    updateState,
    useCase,
    selectedTemplate,
    isEditDisabled,
    isPreview,
    emailHeading,
    emailTitle,
    emailSubject,
    buttonText = "Redeem now",
    company_primary_logo,
    site_id,
  } = props;

  const handleSubject = (event) => {
    updateState({ emailSubject: event.target.value });
  };

  const toggleLogoModal = () => {
    setOpenLogoUploadModal(!openLogoUploadModal);
  };

  const toggleTextModal = () => {
    setOpenBtnTextModal(!openBtnTextModal);
  };

  const handleTextUpdate = (text) => {
    setOpenBtnTextModal(false);
    updateState({ buttonText: text });
  };

  const fetchAlbumCategory = () => {
    setLoader(true);
    profileService
      .fetchAlbumCategory()
      .then((response) => {
        if (
          response?.data?.fetchCategoryList?.error == false &&
          response?.data?.fetchCategoryList?.data?.length > 0
        ) {
          let categoryList = response.data.fetchCategoryList.data;
          categoryList.sort((a, b) =>
            a.category_name > b.category_name
              ? 1
              : b.category_name > a.category_name
                ? -1
                : 0
          );
          categoryList.splice(0, 0, { category_id: 0, category_name: "All" });
          let selectedCategory = categoryList[0];
          setCategoryList(categoryList);
          setSelectedCategory(selectedCategory);
          getInitialAlbum();
          // setLoader(false);
        } else {
          setCategoryList([]);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  const getSelectedTemplate = (cardImages, selectedImage) => {
    let newSelectedImage = selectedImage || selectedTemplate;
    cardImages.map((image) => {
      if (image.image_id === newSelectedImage.image_id) {
        image.selected = true;
        newSelectedImage = image;
      }
    });
    if (!newSelectedImage) {
      newSelectedImage = JSON.parse(JSON.stringify(DEFAULT_TEMPLATE));
    }
    updateState({ selectedTemplate: newSelectedImage });
    setLoader(false)
  };
  const getInitialAlbum = () => {
    let promises = [];
    let { selectedTemplate } = props;
    promises.push(transactionService.getCardImages({ all_category: 1 }));
    promises.push(transactionService.getCardImages({ all_category: 2 }));
    setLoader(true);
    Promise.all(promises)
      .then((response) => {
        let finalAlbum = [];
        if (
          response[0] &&
          response[0].fetchAlbumList &&
          response[0].fetchAlbumList.data &&
          response[1] &&
          response[1].fetchAlbumList &&
          response[1].fetchAlbumList.data
        ) {
          finalAlbum = [
            ...response[0].fetchAlbumList.data,
            ...response[1].fetchAlbumList.data,
          ];
          finalAlbum.map((image) => {
            if (image.image_id === selectedTemplate.image_id) {
              image.selected = true;
              selectedTemplate = image;
            } else {
              image.selected = false;
            }
          });
          if (selectedTemplate.album_id !== 1) {
            updateState && updateState({ selectedTemplate });
          }
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
      })
      .then(() => {
        setLoader(false);
        // setCardImages(cardImages)
      });
  };

  const getCardImages = (params = { all_category: 1 }, selectedImage) => {
    setLoader(true);
    const albumReq = "storesAdmin.query.template_fetch_album";
    const cardImagesQuery = {
      query: albumReq,
      tag: "storeAdmin",
      variables: {
        cat_data: {
          ...params,
        },
      },
    };
    let cardImages = [];
    makeRequestAuth(
      cardImagesQuery,
      function (response) {
        if (response && response.data.fetchAlbumList.data) {
          cardImages = response.data.fetchAlbumList.data;
          cardImages.map((item) => {
            item.selected = false;
          });
        }

        setCardImages(cardImages);
        getSelectedTemplate(cardImages, selectedImage);
      }.bind(this)
    );
  };

  const onSearch = (query) => {
    setLoader(true);

    let payload = {
      all_category: 1,
      album_name: query,
    };

    const albumReq = "storesAdmin.query.template_fetch_album";

    const request_data = {
      query: albumReq,
      tag: "storeAdmin",
      variables: {
        cat_data: payload,
      },
    };

    let cardImages = [];
    makeRequestAuth(
      request_data,
      function (response) {
        if (response?.data?.fetchAlbumList?.data) {
          cardImages = response.data.fetchAlbumList.data;
          cardImages.map((item) => {
            item.selected = false;
          });
        }
        let stateData = {
          cardImages,
          selectedCategory: {},
          loader: false,
        };
        setCardImages(cardImages);
        setSelectedCategory({});
        setLoader(false);
        getSelectedTemplate(cardImages);
      }.bind(this)
    );
  };

  const deleteCardImage = (image_id) => {
    let { selectedTemplate } = props;
    if (selectedTemplate.image_id === image_id) {
      NotificationManager.warning(
        "This banner is in use and cannot be deleted."
      );
      return;
    }
    setLoader(true);
    const deleteRequest = "storesAdmin.query.delete_template_image";
    const deleteImagesQuery = {
      query: deleteRequest,
      tag: "storeAdmin",
      variables: {
        img_id: image_id,
      },
    };

    makeRequestAuth(
      deleteImagesQuery,
      function (response) {
        if (response?.data?.deleteTemplateImage?.error === false) {
          NotificationManager.success(
            response?.data?.deleteTemplateImage?.message[0]
          );
        } else {
          NotificationManager.error(
            response?.data?.deleteTemplateImage?.message[0]
          );
        }
        setLoader(false);
        handleCategory();
      }.bind(this)
    );
  };

  const handleCategory = (clickedCategory, selectedImage) => {
    let newSelectedCategory = clickedCategory || selectedCategory;
    const category_id = newSelectedCategory.category_id;
    setSelectedCategory(newSelectedCategory);
    let params = {};
    if (category_id === 0) {
      params.all_category = 1;
    } else if (category_id == 5000) {
      params.all_category = 2;
    } else {
      params.category_id = category_id;
    }
    getCardImages(params, selectedImage);
  };

  const toggleTemplateModal = (selectedImage) => {
    setTemplateModal(!templateModal);
    handleCategory(
      selectedImage?.selectedCategory || categoryList[0],
      selectedImage
    );
  };
  const deleteBanner = () => {
    const { selectedTemplate } = props;
    updateState({
      selectedTemplate: { ...selectedTemplate, image_id: 0, img_path: "", image_url: "" }
    })

  }

  const toggleMsgTextModal = () => {
    setOpenMsgTextModal((prevState) => !prevState.openMsgTextModal);
  };

  const handleUpdateEmailHeading = (text, title) => {
    props.updateState({ emailHeading: text, emailTitle: title });
    setOpenMsgTextModal(false);
  };

  const renderEmailBody = () => {
    const { useCase = "", emailHeading, emailTitle, isEditDisabled = false } = props;
    return <div>
      <Typography.H1 className="mb-16">
        {emailTitle}
      </Typography.H1>
      <Typography style={{
        wordBreak: "break-all"
      }} className="px-10">
        Hi {" "}
        {useCase === "code-campaign" ||
          useCase === "code-distribution" ||
          useCase === "points-distribution" ||
          useCase === "link-distribution" ||
          useCase === "link-campaign" ||
          useCase === "plum-pro-distribution" ? (
          <>{`<recipient name>`}</>
        ) : null}
        <br />
        <span dangerouslySetInnerHTML={{ __html: emailHeading }} />
      </Typography>
      {!isEditDisabled ? (
        <EditMask
          toggleModalState={() => toggleMsgTextModal()}
          buttonText="Message"
          top={0}
        />
      ) : null}

      <Typography className="d-flex align-items-center justify-content-center mb-0" style={{
        "fontStyle": "italic"
      }}> {`<personal message to recipient will come here if available>`} </Typography>
    </div>

  };

  const renderRewardSection = () => {
    const {
      useCase = "",
      denomination_val,
      validTill,
      selectedDate,
      currencyCode = "INR",
      accountReducer: { platformSettings } = {},
    } = props;
    if (useCase === "link-campaign" || useCase === "link-distribution") {
      return (
        <XoxoLinkRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          currencyCode={currencyCode}
          toggleTextModal={toggleTextModal}
          buttonText={buttonText}
        />
      );
    } else if (useCase === "code-campaign" || useCase === "code-distribution") {
      return (
        <XoxoCodeRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          currencyCode={currencyCode}
          toggleTextModal={toggleTextModal}
          buttonText={buttonText}
        />
      );
    } else if (useCase === "points-distribution") {
      return (
        <XoxoPointRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          platformSetting={platformSettings}
          toggleTextModal={toggleTextModal}
          buttonText={buttonText}
        />
      );
    } else if (useCase === "plum-pro-distribution") {
      return (
        <PlumProRewardBody
          selectedValue={denomination_val}
          validTill={validTill}
          selectedDate={selectedDate}
          currencyCode={currencyCode}
          toggleTextModal={toggleTextModal}
          buttonText={buttonText}
        />
      );
    }
  };

  useEffect(() => {
    fetchAlbumCategory();
  }, []);

  const imgSrc = selectedTemplate?.image_id ?
    (selectedTemplate?.img_path
      ? config.album_image_s3_url + selectedTemplate?.img_path
      : selectedTemplate.image_url) : ""

  return (
    <div className="mb-24">
      {!isPreview && (
        <div>
          <div>
            <Typography.LabelText
              className="text-left mt-24 mb-12"
              color="dark"
              shade="c300"
            >
              Choose Category
            </Typography.LabelText>
            <Templates
              isEdit={true}
              accountReducer={props.accountReducer}
              updateState={props.updateState}
              useCase={useCase}
              selectedTemplate={selectedTemplate}
              selectedDate={props.selectedDate}
              currencyCode={props.currencyCode}
              denomination_val={props.denomination_val}
              validTill={props.validTill}
            />
          </div>
        </div>
      )}
      <div
        className="w-100 p-20 mt-28"
        style={{
          backgroundColor: theme.palette.light.c100,
        }}
      >
        {!isPreview && (
          <>
            <Typography.LabelText className="text-left mb-4">
              Preview
            </Typography.LabelText>
            <Input
              label="Email Subject"
              limit={maxLimit}
              value={emailSubject}
              onChange={handleSubject}
              placeholder={emailSubject}
              disabled={isEditDisabled}
              error={emailSubject?.length === 0 ? true : false}
              className="mt-24"
              helperText={
                emailSubject?.length === 0
                  ? "Email subject cannot be left blank."
                  : ""
              }
              style={{
                backgroundColor: theme.palette.common.white,
              }}
            />
          </>
        )}
        <div
          className="bg-white mx-auto"
          style={{
            maxWidth: "600px",
            boxShadow: "0px 8px 20px 1px rgba(56, 42, 106, 0.10)",
          }}
        >
          <div>
            {uploadingLogo ? (
              <div className="d-flex justify-content-center align-items-center">
                <CircularLoader />
              </div>
            ) : (
              <div className="px-12 py-20 position-relative">
                {!isEditDisabled ? (
                  <EditMask
                    buttonText="Logo"
                    toggleModalState={() => toggleLogoModal()}
                    top={0}
                  />
                ) : null}
                <LogoPreview imgSrc={company_primary_logo} />
              </div>
            )}
          </div>
          <div>
            {loader && isPreview && !selectedTemplate?.img_path ? (
              <div className="d-flex justify-content-center align-items-center">
                <CircularLoader />
              </div>
            ) : (
              <div className="position-relative">
                {!isEditDisabled && !isPreview ? (
                  <EditMask
                    buttonText="Banner"
                    toggleModalState={() => toggleTemplateModal()}
                    deleteBanner={deleteBanner}
                    imgSrc={imgSrc}
                  />
                ) : null}
                <TemplatePreview
                  loader={loader}
                  imgSrc={imgSrc}
                  toggleModalState={() => toggleTemplateModal()}
                />
              </div>
            )}
          </div>
          <div className=" px-10">
            <div
              className="pt-32 pb-32 mt-12 text-center"
              style={{ backgroundColor: theme.palette.light.c100 }}
            >
              <div className="position-relative">

                <div className="position-relative py-12">
                  {renderEmailBody()}
                </div>
              </div>
              <div
                className="mt-28 mb-12 px-20 py-28 mx-auto"
                style={{
                  maxWidth: "262px",
                  boxShadow: "0px 8px 20px 1px rgba(56, 42, 106, 0.10)",
                }}
              >
                {renderRewardSection()}
              </div>
            </div>
          </div>
          <EmailFooter
            isDesktopPreview={isDesktopPreview}
            getHowToUseLinks={getHowToUseLinks}
            useCase={useCase}
          />
        </div>
        {(useCase === "code-campaign" || useCase === "code-distribution") && (
          <div className="d-flex align-items-center justify-content-center mt-24">
            <Icon
              iconName="Info"
              color="orange"
              shade="c200"
              className="mr-8"
            />
            <Typography.HelperText color="dark" shade="c200">
              Codes are sent as email attachment if quantity is more than 5
            </Typography.HelperText>
          </div>
        )}
      </div>

      {openLogoUploadModal ? (
        <EditLogoModal
          toggleModal={() => setOpenLogoUploadModal(false)}
          logoSrc={company_primary_logo}
          setNewLogo={(logoUrl) => updateState({ emailLogo: logoUrl })}
        />
      ) : null}
      {templateModal ? (
        <TemplateModal
          site_id={site_id}
          cardImages={cardImages}
          loader={loader}
          getCardImages={getCardImages}
          callbackMethod={toggleTemplateModal}
          updateState={updateState}
          deleteCardImage={(img_id) => deleteCardImage(img_id)}
          categoryList={categoryList}
          selectedCategory={selectedCategory}
          handleCategory={handleCategory}
          selectedTemplate={selectedTemplate}
          onSearch={onSearch}
        />
      ) : null}
      {openBtnTextModal ? (
        <EditBtnTextModal
          toggleModal={() => setOpenBtnTextModal(false)}
          buttonText={buttonText}
          updateBtnText={(text) => handleTextUpdate(text)}
        />
      ) : null}
      {openMsgTextModal ? (
        <EditMsgTextModal
          toggleModal={() => setOpenMsgTextModal(false)}
          updateEmailMsgText={(text, title) => handleUpdateEmailHeading(text, title)}
          emailHeading={emailHeading}
          emailTitle={emailTitle}
        />
      ) : null}
    </div>
  );
};

export default NewEmailPreview;
